import React from "react";
import { Loader2 } from "lucide-react";

export default function Loader({ label = "Loading intel…" }) {
    return (
        <div className="flex items-center justify-center py-16 text-muted-foreground">
            <Loader2 className="animate-spin mr-2 text-hazard" size={18} /> {label}
        </div>
    );
}
